export function getInscriptionCollectionSlugs(inscription: any): string[] {
	const slugs = Array.isArray(inscription?.collection_slugs)
		? inscription.collection_slugs.filter(Boolean)
		: []

	if (slugs.length > 0) {
		return slugs
	}

	return inscription?.collection?.slug ? [inscription.collection.slug] : []
}

export function inscriptionBelongsToCollection(inscription: any, slug: string): boolean {
	return getInscriptionCollectionSlugs(inscription).includes(slug)
}
